<celum-icon
  class="celum-systembar-formats_icon"
  [configuration]="iconConfiguration"
  [matMenuTriggerFor]="contextMenuItems()?.length > 1 && serviceContextMenu"
  (menuOpened)="isMenuOpen.set(true)"
  (menuClosed)="isMenuOpen.set(false)"
  (click)="onIconClick($event)"></celum-icon>

<mat-menu #serviceContextMenu="matMenu" class="celum-scrollbar celum-systembar-formats_menu" yPosition="above">
  @for (contextMenuItem of contextMenuItems(); track contextMenuItem.text) {
    <button
      class="celum-systembar-formats_menu-item"
      mat-menu-item
      spaceAwareTooltip
      [attr.data-component-id]="contextMenuItem.dataComponentId"
      [matTooltip]="contextMenuItem.text | stripUrlProtocol"
      (click)="contextMenuItem.onClick()">
      {{ contextMenuItem.text | stripUrlProtocol }}
    </button>
  }
</mat-menu>
